import { render, staticRenderFns } from "./PageWorkouts.vue?vue&type=template&id=2fcdbca0&scoped=true"
import script from "./PageWorkouts.vue?vue&type=script&lang=js"
export * from "./PageWorkouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcdbca0",
  null
  
)

export default component.exports